"use strict";

jQuery(document).ready(function ($) {
  var initButtons = function initButtons() {
    $('.layout-tabbed-content .btn').on('click', function (e) {
      var button = $(this);
      var thisUrl = button.attr('href');
      if (thisUrl === '#') {
        e.preventDefault();
        var thisTabContent = button.parents('.tab__content');
        var isSlicked = button.closest('.layout-tabbed-content--tabs');
        thisTabContent.removeClass('active').siblings().removeClass('active');
        thisTabContent.next().addClass('active').next().addClass('active');
        if (isSlicked.hasClass('slick-initialized')) {
          isSlicked.slick('slickNext');
        }
      }
    });
  };
  var initTabTitleAndContent = function initTabTitleAndContent() {
    $('.layout-tabbed-content .tab__title').removeClass('active');
    $('.layout-tabbed-content .tab__content').removeClass('active');
    var firstTab = $('.layout-tabbed-content .tab__title:first');
    firstTab.addClass('active').next().addClass('active');
    $('.layout-tabbed-content .tab__title').on('click', function () {
      var selectedTab = $(this);
      var selectedContent = selectedTab.next();
      selectedTab.addClass('active').siblings().removeClass('active');
      selectedContent.addClass('active');
    });
    initButtons();
  };
  var checkTabbedContent = function checkTabbedContent() {
    var windowWidth = $(window).width();
    $('.layout-tabbed-content--tabs').each(function () {
      var $carousel = $(this);
      /* Initializes a slick carousel only on mobile screens */
      // slick on mobile
      if (windowWidth > 900) {
        if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
          initTabTitleAndContent();
        }
      } else {
        if (!$carousel.hasClass('slick-initialized')) {
          $carousel.slick({
            autoplay: false,
            arrows: false,
            dots: true,
            dotsClass: 'layout-tabbed-content__dots',
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 2,
            slidesPerRow: 1,
            fade: true,
            mobileFirst: true,
            infinite: false,
            adaptiveHeight: true
          });
        }
        initButtons();
      }
    });
  };
  initTabTitleAndContent();
  window.onresize = checkTabbedContent;
  checkTabbedContent();
});